module.exports = __webpack_public_path__ + "media/stylesheets/images/Yasuaki Kimura-097053db8af4961cf2d6b9b328bb5d7a.jpg";